import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { PercentageSlider } from '../ui/PercentageSlider'
import { PercentagePresets } from '../ui/PercentagePresets'
import { Typography } from '../ui/Typography'

export const CommissionControl: FC<{
  value: number
  onChange: (value: number) => void
  presetValues?: number[]
  label: string
  disabled?: boolean
  className?: string
}> = ({
  value,
  onChange,
  presetValues = [5, 10, 15, 20],
  label,
  disabled = false,
  className,
}) => {
  return (
    <Container className={className}>
      <Typography fontSize={12} fontWeight={400} font="roboto">
        {label}
      </Typography>

      <PercentageSlider
        value={value}
        onChange={onChange}
        min={0}
        max={40}
        step={0.5}
        disabled={disabled}
      />

      <PercentagePresets
        values={presetValues}
        selectedValue={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Container>
  )
}

const Container = styled.div`
  display: grid;
  gap: 6px;
  width: 100%;
`
